import './assets/css/main.scss';
import * as bootstrap from 'bootstrap';

import { createApp } from 'vue';
import { createPinia } from 'pinia';

import App from './App.vue';
import router from './router';
import VueAxios from 'vue-axios';
import axios from 'axios';
import { AXIOS } from './const';
import { setInterceptor } from './router/axios';
import { IMaskDirective } from 'vue-imask';

const app = createApp(App);

const newModalsComponents = import.meta.glob('./components/newModals/**/*.vue', { eager: true });
Object.entries(newModalsComponents).forEach(([path, module]) => {
  const componentName = path.split('/').pop().replace('.vue', '');
  app.component(componentName, module.default);
});

app.use(createPinia());

setInterceptor(axios);
app.use(VueAxios, axios);
app.provide(AXIOS, axios);

app.use(router);
app.directive('mask', IMaskDirective);

app.mount('#app');
